import * as Actions from 'store/actions/app/payment_types.actions'

const initialState = {
  loading_payment_types: false,
  payment_types: []
}

const paymentTypesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_PAYMENT_TYPES: {
      return {
        ...state,
        loading_payment_types: action.payload.loading ?? state.loading_payment_types,
        payment_types: action.payload.data ?? state.payment_types,
      }
    }
    default: {
      return state
    }
  }
}

export default paymentTypesReducer
